/**
 * Classe para formatar dados dos minutos.
 * @author: @augustomna2010
 */



Monet.Format = Monet.Format || {};
Monet.Format.TIME_MINUTES = (function () {

    function TIME_MINUTES(value) {

        Monet.Format.SECONDS.apply(this, arguments);

        this.value = value;

        this.getHourMinute = function () {

            return {
                'hours': Math.floor(this.value / 60),
                'minutes': Math.floor(this.value)
            };

        };

        this.formatToElapsedTime = function () {

            var isLessThanZero = this.value < 0;

            if (isLessThanZero) {
                this.value *= -1;
            }

            var timeFormatted = [];
            var hourAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.hourAbreviation");
            var minuteAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.minuteAbreviation");

            var time = this.getHourMinute();

            if (time.minutes >= 60) {
                time.minutes = time.minutes % 60;
            }

            if (time.hours > 0) {
                timeFormatted.push(time.hours + hourAbreviation);
            }

            if (time.minutes) {
                timeFormatted.push(time.minutes+ minuteAbreviation);
            }

            this.value = timeFormatted.join(' : ');

            if (isLessThanZero) {
                this.value =  "-" +  this.value;
            }

            return this;

        };

        this.toGrid = function(){
            this.formatToElapsedTime();
            return this;
        };
    }

    return TIME_MINUTES;

}());
